import {ChangeDetectorRef, Component, EventEmitter, forwardRef, Input, Optional, Output} from "@angular/core";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {FUIAbstractControl} from "../framework/abstract-control";
import {FUIFormContext} from "../../form-context/form-context";
import {FUIOptionsService} from "../framework/options.service";

@Component({
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FUIAutocompleteControlComponent),
            multi: true
        },
        FUIOptionsService
    ],
    selector: "fui-autocomplete-control",
    templateUrl: "./autocomplete-control.component.html"
})
export class FUIAutocompleteControlComponent extends FUIAbstractControl {
    @Output() public filtered$: EventEmitter<string>;
    @Input() public labelField: string;
    private _options: Array<any>;
    @Input() public total: number;
    @Input() public valueField: string;

    constructor(changeDetectorRef: ChangeDetectorRef,
                @Optional() public context: FUIFormContext) {
        super(changeDetectorRef);
        this.filtered$ = new EventEmitter<string>();
    }

    /**
     *
     * @returns {Array<any>}
     */
    get options(): Array<any> {
        return this._options;
    }

    /**
     *
     * @param {Array<any>} options
     */
    @Input()
    set options(options: Array<any>) {
        this._options = options;
    }
}
